import React from 'react';

import { useAccount } from '@/hooks/useAccount';

import OneNightStandVariant from '../OneNightStand/OneNightStand';
import OneNightStandManVariant from '../OneNightStandMan/OneNightStandMan';

const MultigenderVariant: React.FC = () => {
  const { user } = useAccount();

  if (user?.onboarding_data.gender === 'male') {
    return <OneNightStandManVariant />;
  }

  return <OneNightStandVariant />;
};

export default MultigenderVariant;
